import React, { useState } from 'react';
import PropTypes from 'prop-types';

import capitalize from 'lodash/capitalize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/pro-solid-svg-icons';

import CompSelectorModal from 'components/comps/selector/modal';
import EmptyState from './empty_state';
import PropertyComp from './property_comp';

import { put } from 'helpers/api';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export function PropertyComps({ coordinates, paths, propertyComps, type, onChange, onRemove, onReorder }) {
  const [showSelector, setShowSelector] = useState();

  let content;
  if (propertyComps.length) {
    content = propertyComps.map((propertyComp, index) => (
      <PropertyComp
        index={index}
        key={propertyComp.id}
        propertyComp={propertyComp}
        onRemove={onRemove}
        onReorder={onReorder}
      />
    ));
  } else {
    content = <EmptyState type={type} />;
  }

  async function save(comps) {
    const propertyComps = await put(paths.index, { comps, type });
    setShowSelector(false);
    onChange(propertyComps);
  }

  return (
    <div className="property-comps-container">
      <div className="property-comps-header">
        <h2>{capitalize(type)} Comps</h2>
        <span className="edit-control" name="edit" onClick={() => setShowSelector(true)}>
          <FontAwesomeIcon icon={faCog} size="lg" />
          Edit {capitalize(type)} Comps
        </span>
      </div>

      <div className="property-comps">
        {content}
      </div>

      <CompSelectorModal
        coordinates={coordinates}
        defaultSelectedComps={propertyComps.map(propertyComp => propertyComp.researchComp)}
        show={showSelector}
        type={type}
        onCancel={() => setShowSelector(false)}
        onSave={save}
      />
    </div>
  );
}

PropertyComps.propTypes = {
  coordinates: PropTypes.object,
  paths: PropTypes.shape({
    index: PropTypes.string.isRequired,
  }).isRequired,
  propertyComps: PropTypes.arrayOf(PropTypes.shape({
    researchComp: PropTypes.object.isRequired,
  })).isRequired,
  type: PropTypes.oneOf(['lease', 'sale']).isRequired,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  onReorder: PropTypes.func,
};

export default reorderableList(PropertyComps);
